import { Button, Input, Modal } from "antd";
import { useState } from "react";
import paymentSuccessGif from "../../Assets/images/payment-success-gif.gif";

export default function PaymentSuccess({ isModalOpen, setIsModalOpen }) {
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        closable={true}
        onCancel={handleCancel}
        open={isModalOpen}
        footer={null}
        className="hims-payment-success-card"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "rgba(62, 151, 255, 1)",
              fontSize: "28px",
              fontWeight: "600",
              marginBottom: "32px",
            }}
          >
            Payment Successful
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            Thank you for subscribing{" "}
            <span style={{ color: "rgba(0, 168, 46, 1)" }}>HIMS</span> plan
          </div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            We have received your payment with:
          </div>
          <div className="id-display-container">
            Transaction Id: 88999779989
          </div>
          <div className="id-display-container">Order Id: 88999779989</div>
          <img src={paymentSuccessGif} height={255} width={255} />
        </div>
      </Modal>
    </>
  );
}
